// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2933":"caa2348cbf170172","3185":"91a12fdc34e85f0b"}[chunkId] + ".css";
};